import { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePrefs } from '../store/slices/authSlice.js';

export const TEXT_SCALES = [90, 100, 110, 125, 140];
export const DEFAULT_TEXT_SCALE = 110;
const STORAGE_KEY = 'folioflow-theme-mode';

export function useUiPrefs() {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const prefs = user?.prefs ?? {};
  
  const [localTheme, setLocalTheme] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'light'; } catch { return 'light'; }
  });

  const themeMode = user ? (prefs.themeMode === 'dark' ? 'dark' : 'light') : localTheme;
  const textScale = TEXT_SCALES.includes(prefs.textScale) ? prefs.textScale : DEFAULT_TEXT_SCALE;

  const setPref = useCallback((patch) => {
    if (patch.themeMode) {
      setLocalTheme(patch.themeMode);
      try { localStorage.setItem(STORAGE_KEY, patch.themeMode); } catch {}
    }
    if (user) {
      dispatch(updatePrefs(patch));
    }
  }, [dispatch, user]);

  return { themeMode, textScale, setPref };
}
